import { Button, Select } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import './SelectGroup.scss'

export const SelectGroup = ({
  groups,
  lastGroups,
  searchRecipientsCallback
}) => {
  const intl = useIntl()
  const [group, setGroup] = useState(undefined)
  const [error, setError] = useState(false)
  const [lastGroupsSelected, setLastGroupsSelected] = useState(lastGroups)
  const [lastGroupsList, setLastGroupsList] = useState(lastGroups)

  const withNoGroup = useMemo(() => {
    return [
      {
        value: 0,
        label: intl.formatMessage({
          id: 'Load.SearchRecipients.nessunGruppo'
        })
      },
      ...groups
    ]
  }, [groups])

  const handleChange = (selected) => {
    setGroup(selected)
  }

  const selectGroup = (group) => {
    const listGroup = [
      {
        id: group.id,
        value: group.value,
        selected: true
      }
    ]

    // eslint-disable-next-line array-callback-return
    lastGroupsSelected.map((g) => {
      if (g.value !== group.value) {
        listGroup.push({
          id: g.id,
          value: g.value,
          selected: false
        })
      }
    })

    setLastGroupsSelected(listGroup)
    setGroup(group.id)
  }

  useEffect(() => {
    if (lastGroups && lastGroups.length > 0) {
      setLastGroupsSelected(lastGroups)

      const groupsList = []
      lastGroups.forEach((group) => groupsList.push(group.id))
      setLastGroupsList(groupsList)

      const groups = lastGroups.filter((group) => group.selected)
      if (groups && groups.length > 0) {
        setGroup(groups[0].id)
        initSearchRecipient(groups[0].id)
      }
    }
  }, [lastGroups])

  const searchRecipient = (selectedGroup) => {
    const groups = [selectedGroup]
    lastGroupsList.forEach((group) => {
      if (selectedGroup !== group && groups.length < 3) {
        groups.push(group)
      }
    })

    setLastGroupsList(groups)

    searchRecipientsCallback(
      { includeGroups: [selectedGroup] },
      {
        lastGroups: [...groups],
        lastTypeSelected: 'group'
      },
      []
    ).then((res) => {
      if (res.Items.length === 0) {
        setError(true)
      } else {
        setError(false)
      }
    })
  }

  const initSearchRecipient = (selectedGroup) => {
    searchRecipientsCallback({ includeGroups: [selectedGroup] }, null, []).then(
      (res) => {
        if (res.Items.length === 0) {
          setError(true)
        } else {
          setError(false)
        }
      }
    )
  }

  return (
    <div className='c-select-group'>
      <div className='c-select-group__header'>
        {intl.formatMessage(
          {
            id: 'Load.PreviewViewer.GroupSelection'
          },
          {
            strong: (content) => <strong key={content}>{content}</strong>
          }
        )}
      </div>
      <div className='c-select-group__body'>
        <Select
          placeholder={intl.formatMessage({
            id: 'Load.PreviewViewer.GroupSelectionPlaceholder'
          })}
          options={withNoGroup}
          value={group}
          onChange={handleChange}
          className='c-select-group__body__select'
        />

        <Button
          onClick={() => searchRecipient(group)}
          kind='primary'
          disabled={group === undefined}
          data-mu-test='select-group-apply'
        >
          {intl.formatMessage({ id: 'Load.Common.Apply' })}
        </Button>
      </div>
      {error && (
        <div
          className='c-select-group__error'
          data-mu-test='select-group-error'
        >
          {intl.formatMessage({
            id: 'Load.PreviewViewer.ErrorGroupRecipient'
          })}
        </div>
      )}
      {lastGroupsSelected && lastGroupsSelected.length > 0 && (
        <div className='c-select-group__last-selected'>
          <div className='c-select-group__last-selected__title'>
            {intl.formatMessage({
              id: 'Load.PreviewViewer.LastSelected'
            })}
          </div>
          {lastGroupsSelected &&
            lastGroupsSelected.map((group) => (
              <Button
                className='c-select-group__last-selected__button'
                kind='neutral'
                size='sm'
                disabled={group.selected}
                key={group.id}
                onClick={() => selectGroup(group)}
              >
                {group.value}
              </Button>
            ))}
        </div>
      )}
    </div>
  )
}

SelectGroup.defaultProps = {
  groups: [],
  lastGroups: []
}

SelectGroup.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  lastGroups: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func
}
